import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { OverlayTrigger, Popover,Alert,Form,Col,Row,InputGroup } from 'react-bootstrap';
import { useLocation, useParams, Link } from 'react-router-dom';
import './ArticleDetail.css';
import config from "../../config";  
import { getDetailLink } from "../../utils/utilFunctions";
import { getItemById,getItemList, getItemByOldTitle, getItemImagesByItemId, getItemLangByItemId, getItemListSize, getItemPublicPDFByIdApi, getItemPublicWORDByIdApi, postCommentItem, putUpdateItem, putUpdateItemViewCount } from "../../api";
const ArticleDetail = () => {
    const [showInfo, setShowInfo] = useState(false);
    const [showQuote, setShowQuote] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [imageScale, setImageScale] = useState(1);
    const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const location = useLocation();
    const [isPdfDownloading, setIsPdfDownloading] = useState(false);
    const [item, setItem] = useState({});
    const [relationItemLoading, setRelationItemLoading] = useState(false);
    const [relationItemList, setRelationItemList] = useState([]);
    const [relationStatus, setRelationStatus] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [langItemList, setLangItemList] = useState([]);
    const [langList, setLangList] = useState([]);
    const [modalShow, setModalShow] = useState(false);

    const [customizerStatus, setCustomizerStatus] = useState(true);
    const [customSelectedAlign, setCustomSelectedAlign] = useState("justify");
    const [customFontSize, setCustomFontSize] = useState(18);
    const [customBackgroundColor, setCustomBackgroundColor] = useState("#fff");
    const params = useParams()
    const {id,oldTitle} = params; 
    const getAPI = async () => {
        //console.log('params ', params )
     
        const res = id !== undefined ? await getItemById(id) : await getItemByOldTitle(oldTitle);
        console.log('res ', res )
        if (res.status) {
            setItem(res.data);
            const tempItem = res.data;
            setRelationItemLoading(true);
            setRelationStatus(tempItem.relationItems !== "")
            const res3 = await getItemImagesByItemId(tempItem.id);
            console.log('res3 ', res3 )
            if (res3.status)
                setImageList(res3.data);

            //console.log('tempItem', tempItem)
            if (tempItem.relationItems === "") {
                setRelationItemLoading(true);
                const res1 = await getItemListSize(8);
                setRelationItemList(res1.data);
                setRelationItemLoading(false);
                setRelationStatus(false)
            }
            else {
                setRelationItemList(JSON.parse(tempItem.relationItems));
                setRelationStatus(true)
                setRelationItemLoading(false);
            }
console.log('tempItem ', tempItem )
            if (tempItem.lang !== "" && tempItem.isMultiLang === 1) {

                const res1 = await getItemLangByItemId(tempItem.id);


                if (tempItem.lang === "Türkçe") {
                    setLangList(["Türkçe", ...res1.data.map(x => x.lang)]);
                    setLangItemList([{ lang: "Türkçe", langItemText: tempItem.itemText }, ...res1.data])
                } else {
                    let tr = res1.data.find(x => x.lang === "Türkçe");
                    setLangList(["Türkçe", tempItem.lang, ...res1.data.filter(x => x.lang !== "Türkçe").map(x => x.lang)]);
                    setLangItemList([tr, { lang: tempItem.lang, langItemText: tempItem.itemText }, ...res1.data.filter(x => x.lang !== "Türkçe")])
                }

                // setLangItemList(tlist);
              
            }
            if(tempItem)
                {
                  await updateViewCountApi(tempItem) 
                }
        }

       



    }
    const updateViewCountApi = async (tempItem)=>{
        await putUpdateItemViewCount({id:tempItem.id , viewCount : tempItem.viewCount})
      }

    useEffect(() => {
        //console.log('id ', id )
        if (id !== undefined)
            getAPI();
    }, [id])

    useEffect(() => {
        //console.log('oldTitle ', oldTitle )
        if (oldTitle !== undefined)
            getAPI();
    }, [oldTitle])
 
    const onClickDownload = async(type,lang="tr")=>{
        const selectedLang = { id:1 , langTitle:"Türkçe" }
        if(type==="PDF")
        {
            try {
                setIsPdfDownloading(true);
                const pdfFile = await getItemPublicPDFByIdApi(item.id , lang,selectedLang.id);
          
                const fileUrl = URL.createObjectURL(pdfFile);
                //console.log("item ",item)
                
                 let a = document.createElement('a');
                      a.href = fileUrl;
                      a.target="_blank";
                      a.download =  (lang === "tr" ?  item.title : selectedLang.langTitle) +'.pdf';
                      a.click();
            } catch (error) {
                console.error('PDF indirme hatası:', error);
                alert('PDF indirilirken bir hata oluştu.');
            } finally {
                setIsPdfDownloading(false);
            }
        }
    };
 
    const getItemUrl = (item) => {
        return `${window.location.origin}/article/${item.id}`;
      };

      const handlePrint = () => {
        // Direkt yazdırma ekranını aç
        window.print();
    };
       // Geri Bildirim Modalı
      const FeedbackModal = (props) => {
        const {item} = props;
  
        const [nameSurname, setNameSurname] = useState("");
        const [mail, setMail] = useState("");
        const [comment, setComment] = useState("");
        const [phone, setPhone] = useState("");
        const [captchaData, setCaptchaData] = useState({ text: '', answer: '' });
        const [captchaAttempts, setCaptchaAttempts] = useState(0);
        const [isBlocked, setIsBlocked] = useState(false);
        const [blockUntil, setBlockUntil] = useState(0);
        const [lastSubmission, setLastSubmission] = useState(0);
        const [userCaptchaInput, setUserCaptchaInput] = useState("");

        // Daha karmaşık matematik işlemleri
        const generateAdvancedCaptcha = () => {
          const operations = [
            { op: '+', fn: (a, b) => a + b, maxA: 50, maxB: 30 },
            { op: '-', fn: (a, b) => a - b, maxA: 50, maxB: 30 },
            { op: '×', fn: (a, b) => a * b, maxA: 12, maxB: 8 },
            { op: '÷', fn: (a, b) => a * b, maxA: 12, maxB: 8 } // Bölme için çarpım kullan
          ];
          
          const operation = operations[Math.floor(Math.random() * operations.length)];
          const a = Math.floor(Math.random() * operation.maxA) + 1;
          const b = Math.floor(Math.random() * operation.maxB) + 1;
          
          let question, answer;
          
          if (operation.op === '÷') {
            // Bölme için: a × b ÷ b = a
            question = `${a * b} ÷ ${b} = ?`;
            answer = a.toString();
          } else {
            question = `${a} ${operation.op} ${b} = ?`;
            answer = operation.fn(a, b).toString();
          }
          
          return { text: question, answer };
        };

        const validateCaptcha = (input) => {
          // Blok kontrolü
          if (isBlocked && Date.now() < blockUntil) {
            const remainingTime = Math.ceil((blockUntil - Date.now()) / 1000);
            alert(`Çok fazla deneme! ${remainingTime} saniye bekleyin.`);
            return false;
          }
          
          // Rate limiting
          const now = Date.now();
          if (now - lastSubmission < 30000) { // 30 saniye
            alert("Çok hızlı gönderim! 30 saniye bekleyin.");
            return false;
          }
          
          // Captcha doğrulama
          if (input.trim() !== captchaData.answer) {
            setCaptchaAttempts(prev => prev + 1);
            
            if (captchaAttempts >= 2) { // 3 deneme hakkı
              setIsBlocked(true);
              setBlockUntil(now + 300000); // 5 dakika blok
              setCaptchaAttempts(0);
              alert("Çok fazla hatalı deneme! 5 dakika bekleyin.");
            } else {
              alert(`Yanlış cevap! ${2 - captchaAttempts} deneme hakkınız kaldı.`);
            }
            return false;
          }
          
          // Başarılı
          setCaptchaAttempts(0);
          return true;
        };

        // Modal açıldığında captcha oluştur
        useEffect(() => {
          if (props.show) {
            setCaptchaData(generateAdvancedCaptcha());
            setUserCaptchaInput("");
            setCaptchaAttempts(0);
            setIsBlocked(false);
            setBlockUntil(0);
          }
        }, [props.show]);

        const saveComment = async()=>{
          if (!validateCaptcha(userCaptchaInput)) {
            return;
          }
          
          // Başarılı gönderim
          setLastSubmission(Date.now());
          
          const data = { 
            nameSurname,
            mail,
            phone,
            comment,
            itemId : item.id
          }

          if(nameSurname.length>0 && mail.length>0 && comment.length>1)
          {
            const res = await postCommentItem(data);
            if(res.status)
            {
              alert("Mesaj gönderme başarılı");
              // Form alanlarını temizle
              setNameSurname("");
              setMail("");
              setPhone("");
              setComment("");
              // Captcha kodunu yenile
              setCaptchaData(generateAdvancedCaptcha());
              setUserCaptchaInput("");
              setCaptchaAttempts(0);
              props.onHide();
            }
          }
          else
          {
            alert("Mesaj Gönderme başarısız" )
          }
        }

        return (
          <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {config.project.name} Madde Mesaj Formu
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Alert variant="warning" className="mb-3">
                Bu formun yalnızca <strong>{item.title} </strong> 
                maddesi ile ilgili mesajlar için kullanılması, TÜRKSA Ansiklopedisi'ne ilişkin diğer hususların 
                <a href="/iletisim"> İletişim Formu</a> üzerinden iletilmesi rica
                olunur.
              </Alert>

              <Form method="POST">
                <Form.Group className="mb-3">
                  <Form.Label>Mesajınız*</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Ayrıntılı olarak mesajınızı yazınız."
                    rows={2}
                    onChange={e=>setComment(e.target.value)}
                    value={comment}
                  />
                </Form.Group>
                
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <Form.Label>Ad Soyad*</Form.Label>
                      <Form.Control 
                        type="text"  
                        onChange={e=>setNameSurname(e.target.value)} 
                        value={nameSurname} 
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <Form.Label>E-posta*</Form.Label>
                      <Form.Control 
                        type="email" 
                        onChange={e=>setMail(e.target.value)}  
                        value={mail} 
                        placeholder="isim@ornek.com" 
                      />
                    </Form.Group>
                  </div>
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Telefon</Form.Label>
                  <Form.Control 
                    type="number" 
                    onChange={e=>setPhone(e.target.value)}  
                    value={phone} 
                    placeholder="05XXXXXXXXX" 
                  />
                </Form.Group>

                <div className="captcha-container">
                  <div className="d-flex flex-column gap-2">
                    <div className="captcha-box d-flex align-items-center">
                      <span className="me-2">Doğrulama:</span>
                      <div className="captcha-code-container d-flex align-items-center">
                        <span className="captcha-code me-2">{captchaData.text}</span>
                        <button 
                          type="button" 
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => setCaptchaData(generateAdvancedCaptcha())}
                          title="Yeni soru oluştur"
                        >
                          🔄
                        </button>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      placeholder="Cevabı girin"
                      value={userCaptchaInput}
                      onChange={(e) => setUserCaptchaInput(e.target.value)}
                      style={{ width: '100%', maxWidth: '300px' }}
                    />
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={props.onHide} variant="secondary">
                Kapat
              </Button>
              <Button onClick={()=>saveComment()} variant="danger" className="text-white">
                Gönder
              </Button>
            </Modal.Footer>
          </Modal>
        );
      };
    const popover = (item) => (
        <Popover id="popover-basic">
          <Popover.Header as="h3">{item.title}</Popover.Header>
          <Popover.Body>
            <div className="textarea">
              <p>
                <span>Yazar:</span> {item.writerName}
              </p>
              <p>
                <span>Web Sitesi:</span> {config.appUrl}
              </p>
              <p>
                <span>Yayımcı:</span> {config.project.name}
              </p>
              <p>
                <span>Erişim Tarihi:</span> {new Date().toLocaleDateString()}
              </p>
              <p>
                <span>Web Sitesi Adresi:</span>{" "}
                {getItemUrl(item)}
              </p>
            </div>
            <p><b>Kopyalama Metni</b></p>
            <p id="atifCopyText">
              {`${item.writerName}, "${item.title}", ${config.project.name},
              ${getItemUrl(item)}
              (${new Date().toLocaleDateString()})`}.
            </p>
          </Popover.Body>
        </Popover>
      );
  
    // Image modal fonksiyonları
    const handleImageClick = (image, index) => {
        setSelectedImage(image);
        setCurrentImageIndex(index);
        setShowImageModal(true);
    };

    const handleCloseImageModal = () => {
        setShowImageModal(false);
        setSelectedImage(null);
        setCurrentImageIndex(0);
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    // Zoom fonksiyonları
    const handleZoomIn = () => {
        setImageScale(prev => Math.min(prev * 1.2, 5)); // Max 5x zoom
    };

    const handleZoomOut = () => {
        setImageScale(prev => Math.max(prev / 1.2, 0.5)); // Min 0.5x zoom
    };

    const handleZoomReset = () => {
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    const handleImageDoubleClick = () => {
        if (imageScale === 1) {
            setImageScale(2);
        } else {
            handleZoomReset();
        }
    };

    // Mouse wheel zoom
    const handleWheel = (e) => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? 0.9 : 1.1;
        setImageScale(prev => Math.min(Math.max(prev * delta, 0.5), 5));
    };

    // Drag fonksiyonları (zoom'lanmış resmi kaydırma için)
    const handleMouseDown = (e) => {
        if (imageScale > 1) {
            setIsDragging(true);
            setDragStart({
                x: e.clientX - imagePosition.x,
                y: e.clientY - imagePosition.y
            });
        }
    };

    const handleMouseMove = (e) => {
        if (isDragging && imageScale > 1) {
            setImagePosition({
                x: e.clientX - dragStart.x,
                y: e.clientY - dragStart.y
            });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const goToPreviousImage = () => {
        const newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : imageList.length - 1;
        setCurrentImageIndex(newIndex);
        setSelectedImage(imageList[newIndex]);
        // Reset zoom when changing images
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    const goToNextImage = () => {
        const newIndex = currentImageIndex < imageList.length - 1 ? currentImageIndex + 1 : 0;
        setCurrentImageIndex(newIndex);
        setSelectedImage(imageList[newIndex]);
        // Reset zoom when changing images
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    // Keyboard navigation için
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (showImageModal) {
                switch (event.key) {
                    case 'Escape':
                        handleCloseImageModal();
                        break;
                    case 'ArrowLeft':
                        goToPreviousImage();
                        break;
                    case 'ArrowRight':
                        goToNextImage();
                        break;
                    case '+':
                    case '=':
                        handleZoomIn();
                        break;
                    case '-':
                        handleZoomOut();
                        break;
                    case '0':
                        handleZoomReset();
                        break;
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [showImageModal, currentImageIndex]);

    const citation = `${item.writerName} (2024). "${item.title}", Akademik Kaynak, Cilt 1, Sayı 1, s. 1-15.`;

    return (
        <div className="article-detail-container">
            <div className="article-actions">
                <img src="/images/turksa/yazici.png" alt="Print" className="action-icon" onClick={handlePrint} />
                <div 
                    className={`pdf-download-button ${isPdfDownloading ? 'downloading' : ''}`} 
                    onClick={() => !isPdfDownloading && onClickDownload("PDF","tr")}
                    title={isPdfDownloading ? "PDF indiriliyor..." : "Bu maddeyi PDF olarak indir"}
                >
                    {isPdfDownloading ? (
                        <svg className="action-icon pdf-loading-icon" viewBox="0 0 24 24" fill="currentColor">
                            <circle cx="12" cy="12" r="3" opacity="0.1"/>
                            <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25"/>
                            <path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z">
                                <animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/>
                            </path>
                        </svg>
                    ) : (
                        <svg className="action-icon pdf-download-icon" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                            <text x="12" y="17" textAnchor="middle" fontSize="7" fill="currentColor" fontWeight="bold">PDF</text>
                        </svg>
                    )}
                </div>
                <img src="/images/turksa/kunye.png" alt="Info" className="action-icon" onClick={() => setShowInfo(true)} />
                <OverlayTrigger
                  trigger="click"
                  placement="left"
                  overlay={popover(item)}
                  rootClose
                >
                  <img 
                      src="/images/turksa/alinti.png" 
                      alt="Quote" 
                      className="action-icon"
                      title="Alıntılama bilgilerini görüntüle"
                  />
                </OverlayTrigger>
                <div 
                  className="feedback-button" 
                  onClick={() => setModalShow(true)}
                  title="Bu madde hakkında bildirimde bulunun"
                >
                  <svg className="action-icon feedback-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20,4H4C2.9,4,2,4.9,2,6V18C2,19.1,2.9,20,4,20H20C21.1,20,22,19.1,22,18V6C22,4.9,21.1,4,20,4M20,8L12,13L4,8V6L12,11L20,6V8Z" />
                  </svg>
                </div>
            </div>

            <div className="article-detail-layout">
                {/* Ana İçerik - Sol */}
                <div className="article-content-main">
                    <div className="article-detail-header">
                        <h1 className="article-detail-title">{item.title}</h1>
                        <h2 className="article-detail-subtitle">{item.definition}</h2>
                    </div>

                    <div className="article-detail-author pt-5">
                        <div className="article-author-detail-info">
                            <Link to={`/yazar/${item.userId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                <div className="author-detail-frame">
                                    <span className="article-author-detail-name">{item.writerName}</span>
                                    <img src="/images/turksa/kenar.png" alt="Edit" className="article-detail-pen-icon" />
                                </div>
                            </Link>
                            <div className="author-detail-institution">
                                {/* {item.inst} */}
                                {/* {articleInfo.department && `, ${articleInfo.department}`} */}
                            </div>
                            {/* {articleInfo.email && (
                                <div className="author-detail-email">
                                    {articleInfo.email}
                                </div>
                            )} */}
                        </div>
                    </div>

                    <div 
                        className="article-detail-text pt-3"
                        dangerouslySetInnerHTML={{ __html: item.itemText }}
                    />
                         {/* Kaynakça Bölümü */}
                         {item.sourceText && (
                        <div className="article-detail-sources pt-4 mt-4">
                            <h3 className="sources-title">Kaynakça</h3>
                            <div 
                                className="sources-content"
                                dangerouslySetInnerHTML={{ __html: item.sourceText }}
                            />
                        </div>
                    )}
                    <div className="article-detail-view-count">
                        <p>
                            <svg className="view-count-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                            </svg>
                            Görüntülenme Sayısı: {item.viewCount}
                        </p>
                    </div>
                </div>

                {/* Resimler ve İlgili Makaleler - Sağ Sidebar */}
                <div className="article-images-sidebar">
                    {/* Resimler */}
                    {imageList.map((image, index) => (
                        <figure key={index} className="article-detail-figure">
                            <img 
                                src={image.url} 
                                alt={image.docTypeTitle}
                                onClick={() => handleImageClick(image, index)}
                                style={{ cursor: 'pointer' }}
                            />
                            <figcaption>{image.docTypeTitle}</figcaption>
                        </figure>
                    ))}
                    
                    {/* İlgili Makaleler - Resimlerin Altında */}
                    <div className="related-articles-sidebar">
                        <h3 className="related-articles-title">İlgili Makaleler</h3>
                        <div className="related-articles-list">
                            {relationItemList.map((relatedItem, index) => (
                                <Link 
                                    key={index} 
                                    to={getDetailLink(relatedItem)} 
                                    className="related-article-item"
                                >
                                    <div className="related-article-thumbnail">
                                        <img 
                                            src={relatedItem.primaryImage || "/images/turksa/miniLogo.png"} 
                                            alt={relatedItem.title}
                                            className="related-article-image"
                                        />
                                    </div>
                                    <div className="related-article-content">
                                        <h4 className="related-article-title">{relatedItem.title}</h4>
                                        <p className="related-article-author">{relatedItem.writerName}</p>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Info Modal */}
            <Modal show={showInfo} onHide={() => setShowInfo(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Madde Künyesi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="article-info">
                        <p><strong>Yazar:</strong> {item.writerName}</p>
                        <p><strong>Başlık:</strong> {item.title}</p>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Quote Modal */}
            <Modal show={showQuote} onHide={() => setShowQuote(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Alıntılama Formatı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="citation-info">
                        <p className="mb-3">Bu makaleyi alıntılamak için:</p>
                        <div className="citation-text p-3 bg-light">
                            {`${item.writerName} (2024). "${item.title}", Akademik Kaynak, Cilt 1, Sayı 1, s. 1-15.`}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => navigator.clipboard.writeText(citation)}>
                        Kopyala
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Image Modal */}
            <Modal 
                show={showImageModal} 
                onHide={handleCloseImageModal} 
                centered 
                size="xl"
                className="image-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedImage?.docTypeTitle}
                        {imageList.length > 1 && (
                            <small className="ms-2">({currentImageIndex + 1} / {imageList.length})</small>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body 
                    className="text-center p-0 position-relative"
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseUp}
                    onWheel={handleWheel}
                    style={{ overflow: 'hidden', cursor: isDragging ? 'grabbing' : (imageScale > 1 ? 'grab' : 'default') }}
                >
                    {selectedImage && (
                        <>
                            <img 
                                src={selectedImage.url} 
                                alt={selectedImage.docTypeTitle}
                                onDoubleClick={handleImageDoubleClick}
                                onMouseDown={handleMouseDown}
                                style={{
                                    maxWidth: imageScale === 1 ? '100%' : `${100 * imageScale}%`,
                                    maxHeight: imageScale === 1 ? '100%' : `${100 * imageScale}%`,
                                    width: imageScale === 1 ? 'auto' : 'auto',
                                    height: imageScale === 1 ? 'auto' : 'auto',
                                    objectFit: 'contain',
                                    transform: `scale(${imageScale}) translate(${imagePosition.x}px, ${imagePosition.y}px)`,
                                    transition: isDragging ? 'none' : 'transform 0.2s ease',
                                    cursor: imageScale > 1 ? 'grab' : 'zoom-in',
                                    userSelect: 'none',
                                    pointerEvents: 'auto'
                                }}
                                draggable={false}
                            />
                            
                            {/* Navigation buttons */}
                            {imageList.length > 1 && (
                                <>
                                    <button
                                        onClick={goToPreviousImage}
                                        className="image-nav-btn image-nav-prev"
                                        aria-label="Önceki resim"
                                    >
                                        &#8249;
                                    </button>
                                    <button
                                        onClick={goToNextImage}
                                        className="image-nav-btn image-nav-next"
                                        aria-label="Sonraki resim"
                                    >
                                        &#8250;
                                    </button>
                                </>
                            )}
                            
                            {/* Zoom controls */}
                            <div className="zoom-controls">
                                <button
                                    onClick={handleZoomOut}
                                    className="zoom-btn zoom-out"
                                    disabled={imageScale <= 0.5}
                                    aria-label="Uzaklaştır"
                                >
                                    −
                                </button>
                                <span className="zoom-level">{Math.round(imageScale * 100)}%</span>
                                <button
                                    onClick={handleZoomIn}
                                    className="zoom-btn zoom-in"
                                    disabled={imageScale >= 5}
                                    aria-label="Yakınlaştır"
                                >
                                    +
                                </button>
                                <button
                                    onClick={handleZoomReset}
                                    className="zoom-btn zoom-reset"
                                    disabled={imageScale === 1 && imagePosition.x === 0 && imagePosition.y === 0}
                                    aria-label="Sıfırla"
                                >
                                    ⌂
                                </button>
                            </div>
                        </>
                    )}
                </Modal.Body>
                {selectedImage?.docTypeTitle && (
                    <Modal.Footer className="justify-content-center">
                        <small className="text-muted">{selectedImage.docTypeTitle}</small>
                        <div className="d-flex flex-wrap justify-content-center gap-3 mt-2">
                            {imageList.length > 1 && (
                                <small className="text-muted">
                                    📱 Gezinme: ← → tuşları
                                </small>
                            )}
                            <small className="text-muted">
                                🔍 Yakınlaştırma: +/- tuşları veya çift tıklama
                            </small>
                            <small className="text-muted">
                                ✋ Kaydırma: Zoom'lanmış resmi sürükleyin
                            </small>
                        </div>
                    </Modal.Footer>
                )}
            </Modal>

              {/* Geri Bildirim Modalı */}
              <FeedbackModal
              show={modalShow}
              onHide={() => setModalShow(false)}
              item={item}
            />
        </div>
    );
};

export default ArticleDetail; 